import { useOutletContext } from "react-router-dom";
import AddedDropDown from "./AddedDropDown";
import DashboardChart from "./DashboardChart";
import Table from "../Table";
import { generalObj } from "../../constant/object_types";
import { ProductSvg, StaffSvg, StoreSvg, VendorSvg } from "../../style/iconStyle";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import { dateStr, fetchDashboard, timeStr } from "../../action/generalFunc";

const AdminDashboard = () => {
    
    const [recentlyAdded, setRecentlyAdded] = useState<generalObj[]>([])

    const [expiringProduct, setExpiringProduct] = useState<generalObj[]>([]);

    const [tickets, setTickets] = useState<generalObj[]>([]);

    const [dashboardStat, setDashboardStat] = useState<generalObj>({
        vendor: 0,
        product: 0,
        staff: 0,
        store: 0
    })
    const [chartData, setChartData] = useState<generalObj | null>(null);
    const {setModalLoading}:{setModalLoading:Function} = useOutletContext();
    const account = useSelector((state:RootState) => state.account);

    useEffect(() => {
        if (!account || !account.isAuthenticated) return;
        (async () => {
            let result = await fetchDashboard(account.token);
            if (result) {
                setDashboardStat({...result.data.stat});
                setTickets(result.data.tickets);
                setExpiringProduct(result.data.expiry);
                setChartData(result.data.chart_data);
                setRecentlyAdded(result.data.added_product);
            }
            setModalLoading(false);
        })();
    }, [account, setModalLoading]);

    return (
        <>
            <div className="col__stats">
                <div className="col__statsItem" style={{backgroundColor:"#EF5F0F"}}>
                    <div className="col__statsItem__content">
                        <span>{dashboardStat.vendor}</span>
                        <span>Vendors</span>
                    </div>
                    <div className="col__statsItem__icon">
                        <VendorSvg />
                    </div>
                </div>

                <div className="col__statsItem" style={{backgroundColor:"#1DCB5F"}}>
                    <div className="col__statsItem__content">
                        <span>{dashboardStat.product}</span>
                        <span>Products</span>
                    </div>
                    <div className="col__statsItem__icon">
                        <ProductSvg />
                    </div>
                </div>

                <div className="col__statsItem" style={{backgroundColor:"#EB212F"}}>
                    <div className="col__statsItem__content">
                        <span>{dashboardStat.staff}</span>
                        <span>Staff</span>
                    </div>
                    <div className="col__statsItem__icon">
                        <StaffSvg />
                    </div>
                </div>

                <div className="col__statsItem">
                    <div className="col__statsItem__content">
                        <span>{dashboardStat.store}</span>
                        <span>Stores</span>
                    </div>
                    <div className="col__statsItem__icon">
                        <StoreSvg />
                    </div>
                </div>
            </div>

            <div className="col__summary">
                <div className="rateSale" style={{width:"65%"}}>
                    {chartData && <DashboardChart color="#EB212F" chart_data={chartData} start_legend={"#EEBEC2"} end_legend={"#EB606A"} /> }
                </div>
                <div style={{width:"35%"}}>
                    <Table title="Recently Added Products" table_head={["S/no", "Products", "Size"]} th_class="neutralText" color={"#EB7839"} thColor={"#FDE3D5"} tableAction={<AddedDropDown />}>
                        <>
                            {recentlyAdded.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <div className="contentWithImg">
                                            <span><img src={item.image} alt={item.name} /></span>
                                            <span>{item.name}</span>
                                        </div>
                                    </td>
                                    <td>{item.size}</td>
                                </tr>
                            ))}
                        </>
                    </Table>
                </div>
            </div>

            <div className="col__summary">
                <div style={{width:"100%"}}>
                    <Table title="About to Expire Products" table_head={["S/no", "ID", "Product name", "Size", "Store", "Vendor", "Quantity", "Expiry Date "]} th_class="white" color={"#1159AB"} thColor={"#1159AB"}>
                        <>
                            {expiringProduct.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>#{item.expiry_id}</td>
                                    <td>
                                        <div className="contentWithImg">
                                            <span><img src={item.image} alt={item.name} /></span>
                                            <span>{item.name}</span>
                                        </div>
                                    </td>
                                    <td>{item.size}</td>
                                    <td>{item.store.name} - {item.store.organization}</td>
                                    <td>{item.vendor.username}</td>
                                    <td>{item.quantity}</td>
                                    <td>{dateStr(item.expiry_date)}</td>
                                </tr>
                            ))}
                        </>
                    </Table>
                </div>
            </div>


            <div className="col__summary">
                <div style={{width:"100%"}}>
                    <Table title="Tickets" table_head={["ID", "Subject", "Message", "Store", "Staff", "Last Update", "Status"]} th_class="white" color={"#45BA72"} thColor={"#00983A"}>
                        <>
                            {tickets.map((item, index) => (
                                <tr key={index}>
                                    <td>#{item.id}</td>
                                    <td>{item.subject}</td>
                                    <td>
                                        <div dangerouslySetInnerHTML={{__html: `${item.messages.message.slice(0, 38)}...`}} />
                                    </td>
                                    <td>{item.store.name} - {item.store.organization}</td>
                                    <td>{item.staff ? item.staff.username : "Awaiting"}</td>
                                    <td>{`${dateStr(item.messages.created_at)} (${timeStr(item.messages.created_at)})`}</td>
                                    <td>
                                        <div className={`status__container ${item.resolved ? "completed" : "pending"}`}>{item.resolved ? "Completed" : "Pending"}</div>
                                    </td>
                                </tr>
                            ))}
                        </>
                    </Table>
                </div>
            </div>
        </>
    )
}

export default AdminDashboard;